import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Form } from 'react-bootstrap';
import Api from '../../../services/Api';
import * as urls from '../../shared/urls';
import { ApiResponse } from 'apisauce';
import { toast } from 'react-toastify';

interface IUpdateKeywordsButtonProps {
    startingDocIds?: string;
    classNames?: string;
}
interface IUpdateKeywordsButtonState {
    showModal: boolean;
    docIds: string;
    processing: boolean;
}
const initialState: IUpdateKeywordsButtonState = {
    showModal: false,
    processing: false,
    docIds: ''
  };

class UpdateKeywordsButton extends React.Component<
    IUpdateKeywordsButtonProps,
    IUpdateKeywordsButtonState
> {
    public constructor(props: IUpdateKeywordsButtonProps) {
        super(props);
        this.state = initialState;
      }

    componentDidMount = () => {
        if (this.props.startingDocIds && this.props.startingDocIds.length > 0) {
            this.setState({ docIds: this.props.startingDocIds });
        }
    };

    onCloseUpdateKeywordsModal = () => {
        //(this.state.mapComponents.view as any).destroy();
        this.setState({ showModal: false });
    };

    onShowModal = () => {
        this.setState({showModal: true});
    }

    onDocIdsChange = (e: React.FormEvent) => {
        let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

        switch (el.dataset.field) {
            case 'docIds':
                this.setState({
                    docIds: el.value,
                });
                break;
            default:
                break;
        }
    };

    doUpdateKeywords = () => {
        var url = urls.UPDATE_KEYWORDS_TO_ONBASE_BY_DOC_IDS
            var docIdsToFix = {'docIdsToFix': this.state.docIds.split(",").map(function (item) {
                return item.trim();
            })};
            this.setState({processing: true});
            Api.post(url, docIdsToFix)
                .then((result: ApiResponse<any>) => {
                    console.debug(result);
                    toast.success("Doc Ids Queued for Keywords Update");
                    this.setState({ processing: false, showModal: false });
                })
                .catch(function (ex) {
                    console.debug(ex);
                    toast.error("Error, see log");
                    this.setState({ processing: false, showModal: false });
                })
                .finally(function () {
                });
    }

    public render() {
        return (
            <React.Fragment>
        <Button
            variant='primary'
            onClick={x => this.onShowModal()}
            className={this.props.classNames}
          >
            <i className="fa-solid fa-up-long"></i> Update Keywords
          </Button>
            <Modal show={this.state.showModal} onHide={this.onCloseUpdateKeywordsModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Update OnBase Keywords for Doc IDs
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Form>
                            <Form.Label>Enter Doc Ids or Crash Keys, ex: 4123456, 221000123</Form.Label>
                            <Form.Group controlId="docIds">
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    data-field="docIds"
                                    placeholder=""
                                    onChange={this.onDocIdsChange}
                                    value={this.state.docIds}
                                />
                            </Form.Group>
                        </Form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {this.state.processing && (
                        <div>
                            Working {"   "}
                            <img
                                src={require("../../../../src/assets/SmartAdmin/img/32/Marty.gif")}
                            />
                        </div>
                    )}
                    <Button
                        variant="danger"
                        onClick={this.onCloseUpdateKeywordsModal}
                        disabled={this.state.processing}
                    >
                        Cancel Action
                    </Button>
                    <Button
                        variant="success"
                        onClick={(e) => this.doUpdateKeywords()}
                        disabled={
                            this.state.processing || this.state.docIds.length == 0
                        }
                    >
                        Update Keywords
                    </Button>
                </Modal.Footer>
            </Modal>
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state: any) {
    return {
        webServiceURL: state.Application.backendURL,
        reportComments: state.Comments.reportComments,
        reports: state.Comments.reports,
        currentUser: state.Application.currentUser,
    };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateKeywordsButton);